import { useTranslation } from "react-i18next";

const UnrecognizedAnswerRowHead = () => {
  const { t } = useTranslation("unrecognizedAnswers");

  return (
    <div className="unrecognized-answer-row unrecognized-answer-row--head">
      <div>{t("table.date")}</div>
      <div>{t("table.task")}</div>
      <div>{t("table.studentAnswer")}</div>
      <div>{t("table.correctAnswer")}</div>
      <div>{t("table.status")}</div>
    </div>
  );
};

export default UnrecognizedAnswerRowHead;
